import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-payment-recon',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-payment-recon.component.html',
  styleUrl: './view-payment-recon.component.css'
})
export class ViewPaymentReconComponent { }
